<template>
  <b-badge
    :variant="variant"
    pill
    class="project-role-badge text-nowrap"
    :class="{ 'project-role-badge--legend': legend }"
  >
    <feather-icon v-if="showIcon" :icon="icon" size="10" class="project-role-badge-icon" />
    {{ label }}
  </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import { roleOption } from '@/utils/project-config'

export default {
  name: 'ProjectRoleBadge',
  components: { BBadge },
  props: {
    role: { type: String, required: true },
    showIcon: { type: Boolean, default: true },
    short: { type: Boolean, default: false },
    /** Static legend chip in team header — not interactive */
    legend: { type: Boolean, default: false },
  },
  computed: {
    option() {
      return roleOption(this.role)
    },
    label() {
      return this.short ? this.option.shortLabel : this.option.label
    },
    variant() {
      return `light-${this.option.variant}`
    },
    icon() {
      return this.option.icon
    },
  },
}
</script>

<style lang="scss" scoped>
.project-role-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding: 0.2rem 0.45rem;
  line-height: 1.2;
  vertical-align: middle;

  &--legend {
    cursor: default;
    pointer-events: auto;
    box-shadow: none;
    border: 1px solid rgba(34, 41, 47, 0.06);
  }
}

.project-role-badge-icon {
  flex-shrink: 0;
  opacity: 0.9;
}
</style>
